import React from 'react'
import ViewLabelValueField from '../frontend_components/ViewLabelValueField'
import { offerTotalsFormatted } from '../../lib/utils'

/**
 * Displays the total price to the client, cost, profit, and margin of an offer
 * @param {object} offerTotals - An object containing the total price to the client, the total profit, the total cost and the margin of the offer
 * #offerTotals
 * #reports
 * @param {boolean} border - A boolean indicating whether or not to display a border above the component
 * @returns {JSX.Element} A JSX element displaying the total price to the client, cost, profit, and margin of an offer
 */
const OfferTotals = ({offerTotals, border}) => {
   //#offerTotals
   const prezzoCliente = offerTotalsFormatted(offerTotals)?.priceToClient
   const margine = offerTotalsFormatted(offerTotals)?.margin
   
   const costo = offerTotalsFormatted(offerTotals)?.cost
   const profitto = offerTotalsFormatted(offerTotals)?.profit
   //console.log("IN CONSOLE TOTALS", offerTotalsFormatted(offerTotals))

  return (
    <>
            
          <ViewLabelValueField
            noBorder={!border}
            boldValue
            label={"PREZZO"}
            value={prezzoCliente}
            //highlight={"blue"}
          />
          <ViewLabelValueField
            noBorder={!border}
            boldValue
            label={"COSTO"}
            value={costo}
            //highlight={"amber"}
          />
          <ViewLabelValueField
            noBorder={!border}
            boldValue
            label={"PROFITTO"}
            value={profitto}
            highlight={offerTotalsFormatted(offerTotals)?.marginColor}
          />
          <ViewLabelValueField
            noBorder={!border}
            boldValue
            label={"MARGINE"}
            value={margine}
            highlight={offerTotalsFormatted(offerTotals)?.marginColor}
          />
    </>
  )
}

export default OfferTotals
